import { render } from "./FeeCalculationModeCard.vue?vue&type=template&id=47e49224"
import script from "./FeeCalculationModeCard.vue?vue&type=script&lang=js"
export * from "./FeeCalculationModeCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__